import React from "react"
import { Plane, Bus, Building2, Globe } from "lucide-react"
import SearchSuggestionsRow from "./SearchSuggestionsRow"

const GROUP_ICONS = {
  airport: Plane,
  bus: Bus,
  hotel: Building2,
  state: Globe,
}

const SearchSuggestionsSection = ({ group, selectedFrom, selectedTo, onSelect }) => {
  const Icon = GROUP_ICONS[group.type] ?? Globe

  return (
    <div className="mb-5">
      {/* Лейбл-разделитель */}
      <div className="flex items-center gap-2 mb-2">
        <Icon className="w-4 h-4 text-dark-red" />
        <span className="text-sm font-medium text-dark-gray uppercase">{group.label}</span>
      </div>

      <div className="space-y-1">
        {group.items.map((item) => {
          const isSelected =
            (selectedFrom?.id === item.id && selectedFrom?.type === item.type) ||
            (selectedTo?.id === item.id && selectedTo?.type === item.type)

          return (
            <SearchSuggestionsRow
              key={`${item.type}-${item.id}`}
              item={{ ...item, is_selected: isSelected }}
              onSelect={onSelect}
            />
          )
        })}
      </div>
    </div>
  )
}

export default SearchSuggestionsSection
